<app-title-bar
  title="Companies"
  description="Pick a company to impersonate, run a bulk import, or review its audit log."
  [showButton]="true"
  buttonText="Onboard company"
  (buttonClick)="onOnboardCompany()"
>
</app-title-bar>

<app-company-list
  [companies]="companies"
  [loading]="loading"
  [errorMessage]="errorMessage"
  [searchTerm]="searchTerm"
  [columns]="['email', 'contact', 'locations', 'created']"
  [rowLinkBase]="['/admin/companies']"
  [menuTemplate]="rowMenu"
  [paginationData]="paginationData"
  (searchTermChange)="onSearchInput($event)"
  (refresh)="loadCompanies()"
  (pageChange)="onPageChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
></app-company-list>

<ng-template #rowMenu let-company>
  <a
    class="company-row-menu__item"
    role="menuitem"
    [routerLink]="['/admin/companies', company.id, 'overview']"
  >
    Manage company
  </a>
  <button
    type="button"
    class="company-row-menu__item"
    role="menuitem"
    [disabled]="!canImpersonate(company)"
    (click)="requestImpersonate(company)"
  >
    Impersonate admin
  </button>
  <a
    class="company-row-menu__item"
    role="menuitem"
    [routerLink]="['/admin/companies', company.id, 'bulk-import']"
  >
    Bulk import
  </a>
  <a
    class="company-row-menu__item"
    role="menuitem"
    [routerLink]="['/admin/companies', company.id, 'audit-log']"
  >
    Audit log
  </a>
</ng-template>

<app-impersonation-confirm-modal
  testId="impersonate-company-dialog"
  *ngIf="impersonateTarget as target"
  titleId="companies-impersonate-title"
  title="Impersonate admin"
  [busy]="impersonateBusy"
  (cancel)="cancelImpersonate()"
  (confirm)="confirmImpersonate()"
>
  Start an impersonation session for <strong>“{{ target.name }}”</strong> as
  {{ adminLabel(target) }}? A new tab will open with the shop admin session.
</app-impersonation-confirm-modal>
